import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { BTBusRequest } from "./BTBusRequest";
import { BTBusRouteRequest } from "./BTBusRouteRequest";
import { BTStudentRouteRequest } from "./BTStudentRouteRequest";
import { BTStudentsToAssignRequest } from "./BTStudentsToAssignRequest";
import { BTImportRequest } from "./BTImportRequest";
import { BTGenericImportExportRequest } from "./BTGenericImportExportRequest";

@Injectable()
export class DataService_BusTrackerBusMaintenance {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	BusMaintenanceTableSelectList() {
		var postResult$ = new Subject();
		var url = "BusTracker/BusMaintenanceTableSelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusInsert(parms: BTBusRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusInsert";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusUpdate(parms: BTBusRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusUpdate";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusToggle(BusID, Active) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusToggle?BusID=" + BusID + "&Active=" + Active;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusInUse(BusID) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusInUse?BusID=" + BusID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusDelete(BusID) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusDelete?BusID=" + BusID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RouteMaintenanceTableSelectList(BusID) {
		var postResult$ = new Subject();
		var url = "BusTracker/RouteMaintenanceTableSelectList?BusID=" + BusID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusRouteInsert(parms: BTBusRouteRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusRouteInsert";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusRouteUpdate(parms: BTBusRouteRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusRouteUpdate";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusRouteToggle(BusRouteID, Active) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusRouteToggle?BusRouteID=" + BusRouteID + "&Active=" + Active;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusRouteInUse(BusRouteID) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusRouteInUse?BusRouteID=" + BusRouteID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusRouteDelete(BusRouteID) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusRouteDelete?BusRouteID=" + BusRouteID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusRouteTypeSelectList() {
		var postResult$ = new Subject();
		var url = "BusTracker/BusRouteTypeSelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StudentAssignedRouteSelectList(BusRouteID, UserID) {
		var postResult$ = new Subject();
		var url = "BusTracker/StudentAssignedRouteSelectList?BusRouteID=" + BusRouteID + "&UserID=" + UserID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StudentsAssignToRoute(parms: BTStudentRouteRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/StudentsAssignToRoute";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StudentsUnassignFromRoute(parms: BTStudentRouteRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/StudentsUnassignFromRoute";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StudentsToAssignSelectList(parms: BTStudentsToAssignRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/StudentsToAssignSelectList";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ImportPreferenceSelect() {
		var postResult$ = new Subject();
		var url = "BusTracker/ImportPreferenceSelect?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusTrackerFormatSelectList() {
		var postResult$ = new Subject();
		var url = "BusTracker/BusTrackerFormatSelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusTrackerImport(parms: BTImportRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusTrackerImport";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ExportBusTrackerData(parms: BTGenericImportExportRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/ExportBusTrackerData?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
